<template>
  <div class="streams">
    <v-container>
      <v-row class="fill-height pa-0 ma-0" justify="center" align="center">
        <v-col cols="12" lg="12" xl="10" md="10" sm="12">
          <v-row class="pa-0 ma-0">
            <v-col cols="12" md="12" lg="6" xl="6" sm="12">
              <v-img eager src="@/assets/live-stream.jpg" height="280px"></v-img>
            </v-col>
            <v-col cols="12" md="12" lg="6" xl="6">
              <div class="font-weight-bold text-h5">
                OUR MISSION
              </div>
              <div class="text-title mb-6 mt-6">
                “Beckton College is uniquely and proudly vocational.
                Our greatest passion is unleashing the potential of individuals,
                communities and businesses; our greatest legacy is the talent of
                our students: skilled, professional and enterprising.”
              </div>
              <div class="font-weight-bold text-h5">
                OUR VISION
              </div>
              <div class="text-title mb-6 mt-6">
                “To provide students with an outstanding learning experience,
                education and skills development to support them into
                higher levels of study and jobs.”
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'Stream',
};
</script>

<style lang="scss" scoped>

</style>
